import { render, staticRenderFns } from "./shareDub.vue?vue&type=template&id=f88b2d18&"
import script from "./shareDub.vue?vue&type=script&lang=js&"
export * from "./shareDub.vue?vue&type=script&lang=js&"
import style0 from "./shareDub.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports